import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RFOPTTracker/GetIncidents`,
	params: { userId, role }
});

export const GetIncidentDetailsRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RFOPTTracker/GetIncidentDetails`,
	params: { userId, tableId }
});

export const GetIncidentDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RFOPTTracker/GetIncidentDropdowns`
});

export const EditIncidentDetailsRequest = incidentTrackerDto => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RFOPTTracker/EditIncidentDetails`,
	data: incidentTrackerDto
});

export const CreateIncidentRequest = incidentTrackerDto => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RFOPTTracker/CreateIncident`,
	data: incidentTrackerDto
});

export const DeleteIncidentRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RFOPTTracker/DeleteIncident`,
	params: { userId, tableId }
});

export const ExportIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RFOPTTracker/ExportIncidents`,
	params: { userId, role }
});

export const GetAutocompleteFieldsRequest = siteId => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RFOPTTracker/GetAutocompleteFields`,
	params: { siteId }
});

export const AddAttachmentRequest = (userId, incidentId, tempFilePath) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RFOPTTracker/AddAttachment`,
	data: { userId, incidentId, tempFilePath }
});

export const DownloadAttachmentRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RFOPTTracker/DownloadAttachment`,
	params: { userId, tableId }
});

export const RemoveAttachmentRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RFOPTTracker/RemoveAttachment`,
	params: { userId, tableId }
});

export const GetCommentsRequest = id => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RFOPTTracker/GetComments`,
	params: { id }
});

export const AddCommentRequest = (trackerCommentDto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RFOPTTracker/AddComment`,
	data: trackerCommentDto
});

export const AddDropdownFieldRequest = (userId, name, value, relations) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RFOPTTracker/AddDropdownField`,
	data: { userId, name, value, relations }
});

export const RemoveDropdownFieldRequest = (userId, name, value, id, relations) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RFOPTTracker/RemoveDropdownField`,
	data: { userId, name, value, id, relations }
});
